import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { DateAdapter } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSelectionList } from '@angular/material/list/selection-list';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment';
import { UrlService } from '../../commons/calendar/prevUrl.service';
import { TimestampFormatPipe } from '../../commons/timestampFormatPipe';
import { NavigatorService } from '../../services/navigator.service';
import { SondaggioRispostaService } from '../../services/sondaggio/sondaggioRisposta.service';
import { CollaboratoreDTO } from '../../shared/dto/domain/collaboratore';
import { SondaggioDTO, SondaggioOptionDTO } from '../../shared/dto/sondaggi/sondaggio';
import { SondaggioRispostaDTO, SondaggioRispostaOptionDTO } from '../../shared/dto/sondaggi/sondaggioRisposta';
import { GenericDetailComponent } from '../../shared/GenericDetailComponent';
import { switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-risposta-sondaggio-detail',
  templateUrl: './risposta-sondaggio-detail.component.html',
  styleUrls: ['./risposta-sondaggio-detail.component.scss']
})
export class SondaggioRispostaDetailComponent extends GenericDetailComponent implements OnInit {
  previousUrl: string;

  locale: string = "it";
  private collaboratore: CollaboratoreDTO;
  private sondaggioRisposta: SondaggioRispostaDTO;
  sondaggio: SondaggioDTO;

  @ViewChild('list')
  private matList: MatSelectionList;

  constructor(
    navigatorService: NavigatorService,
    dialog: MatDialog,
    router: Router,
    dateAdapter: DateAdapter<Date>,
    activatedRoute: ActivatedRoute,
    snackBar: MatSnackBar,
    timestampFormatPipe: TimestampFormatPipe,
    private urlService: UrlService,
    private sondaggioRispostaService: SondaggioRispostaService,
  ) {
    super(
      navigatorService,
      dialog,
      router,
      dateAdapter,
      activatedRoute,
      snackBar,
      timestampFormatPipe
    );

    this.form = new FormGroup({
      risposte: new FormControl([])
    });
  }

  get risposteControl(): FormControl {
    return this.form.get("risposte") as FormControl;
  }

  ngOnInit() {
    this.urlService.previousUrl$.subscribe((previousUrl: string) => {
      this.previousUrl = previousUrl;
    });

    const sondaggioId = Number(this.activeRoute.snapshot.paramMap.get("id"));

    this.activeRoute.queryParamMap.pipe(switchMap(queryParamMap => {
      const collaboratoreSelezionatoId = Number(queryParamMap.get("collaboratoreSelezionatoId"));
      return this.sondaggioRispostaService.readRisposteSondaggioCollaboratore(collaboratoreSelezionatoId, sondaggioId);
    })).subscribe(res => {
      this.sondaggioRisposta = res;
      this.sondaggio = res.sondaggio;
      this.dtoToForm();
    });
  }

  submit() {
    this.formToDto();
    this.sondaggioRispostaService.create(this.sondaggioRisposta).subscribe((res: SondaggioRispostaDTO) => {
      this.snackBar.open("Risposta al sondaggio salvata con successo!", null, { duration: 3000 });
      this.sondaggioRisposta = res;
      this.dtoToForm();
    });
  }

  isMultiple() {
    return this.sondaggio?.numMaxRisposte > 1;
  }

  isChecked(o: SondaggioOptionDTO): boolean {
    return this.risposteControl.value.includes(o.id);
  }

  isSondaggioExpired() {
    const now = moment();
    const dataScadenza = moment(this.sondaggio?.dataScadenza).endOf('day');
    return now.isAfter(dataScadenza)
  }

  disableSubmit(): boolean {
    const selectedOptions = this.risposteControl.value;
    return !this.form.dirty || this.isSondaggioExpired() || selectedOptions.length == 0 || selectedOptions.length > this.sondaggio?.numMaxRisposte;
  }

  disableOption(o: SondaggioOptionDTO): boolean {
    const selectedOptions = this.risposteControl.value;
    return this.isSondaggioExpired() || this.sondaggio?.numMaxRisposte > 1 && selectedOptions.length >= this.sondaggio?.numMaxRisposte && !this.isChecked(o);
  }

  private formToDto(): void {
    this.sondaggioRisposta.risposte = this.risposteControl.value.map((id: number) => {
      let risposta: SondaggioRispostaOptionDTO = new SondaggioRispostaOptionDTO();
      risposta.sondaggioOption = this.sondaggio?.options.find(o => o.id == id);
      return risposta;
    });
  }

  private dtoToForm(): void {
    const optIds = this.sondaggioRisposta.risposte.map(r => r.sondaggioOption.id);
    this.risposteControl.setValue(optIds);
    this.form.markAsPristine();
  }
}
